import { StateCreator } from 'zustand';

import { AutoConnectCameraStatus } from 'src/models/Camera.model';
import { CameraData } from 'src/models/CameraData.model';
import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { QualityPrecheck } from 'src/models/GalenData/QualityPrecheck.model';

import { RemoteBoundStoreState } from './useRemoteBoundStore';

interface StateTypes {
  isCapturing: boolean;
  isCanceling: boolean;
  leftUrl: string;
  rightUrl: string;
  isUploadingLeftImage: boolean;
  isUploadingRightImage: boolean;
  cameraData: CameraData | undefined;
  backendStatus: BackendStatusData | undefined;
  totalLeftImageAttempt: number;
  totalRightImageAttempt: number;
  isAnalyzing: boolean;
  autoConnectCameraStatus: AutoConnectCameraStatus;
  qualityData: QualityPrecheck;
  hasStarted: boolean;
}
type ActionsTypes = {
  setIsCapturing: (isCapturing: boolean) => void;
  setIsCanceling: (isCanceling: boolean) => void;
  setLeftUrl: (leftUrl: string) => void;
  setRightUrl: (rightUrl: string) => void;
  setIsUploadingLeftImage: (isUploadingLeftImage: boolean) => void;
  setIsUploadingRightImage: (isUploadingRightImage: boolean) => void;
  setCameraData: (cameraData: CameraData | undefined) => void;
  setBackendStatus: (backendStatus: BackendStatusData | undefined) => void;
  setTotalLeftImageAttempt: (totalLeftImageAttempt: number) => void;
  setTotalRightImageAttempt: (totalRightImageAttempt: number) => void;
  setIsAnalyzing: (isAnalyzing: boolean) => void;
  setAutoConnectCameraStatus: (status: AutoConnectCameraStatus) => void;
  setQualityData: (qualityData: QualityPrecheck) => void;
  updateQualityData: (qualityData: QualityPrecheck) => void;
  setHasStarted: (hasStarted: boolean) => void;
};

export type CameraSliceTypes = StateTypes & ActionsTypes;

export const createCameraSlice: StateCreator<
  RemoteBoundStoreState,
  [],
  [],
  CameraSliceTypes
> = (set) => ({
  isCapturing: false,
  isCanceling: false,
  leftUrl: '',
  rightUrl: '',
  isUploadingLeftImage: false,
  isUploadingRightImage: false,
  cameraData: undefined,
  backendStatus: undefined,
  totalLeftImageAttempt: 0,
  totalRightImageAttempt: 0,
  isAnalyzing: false,
  autoConnectCameraStatus: AutoConnectCameraStatus.CONNECTING,
  qualityData: {},
  hasStarted: false,
  setIsCapturing: (isCapturing: boolean) => set({ isCapturing }),
  setIsCanceling: (isCanceling: boolean) => set({ isCanceling }),
  setLeftUrl: (leftUrl: string) => set({ leftUrl }),
  setRightUrl: (rightUrl: string) => set({ rightUrl }),
  setIsUploadingLeftImage: (isUploadingLeftImage: boolean) =>
    set({ isUploadingLeftImage }),
  setIsUploadingRightImage: (isUploadingRightImage: boolean) =>
    set({ isUploadingRightImage }),
  setCameraData: (cameraData: CameraData | undefined) => set({ cameraData }),
  setBackendStatus: (backendStatus: BackendStatusData | undefined) =>
    set({ backendStatus }),
  setTotalLeftImageAttempt: (totalLeftImageAttempt: number) =>
    set({ totalLeftImageAttempt }),
  setTotalRightImageAttempt: (totalRightImageAttempt: number) =>
    set({ totalRightImageAttempt }),
  setIsAnalyzing: (isAnalyzing: boolean) => set({ isAnalyzing }),
  setAutoConnectCameraStatus: (status: AutoConnectCameraStatus) =>
    set({ autoConnectCameraStatus: status }),
  setQualityData: (qualityData: QualityPrecheck) => set({ qualityData }),
  updateQualityData: (qualityData: QualityPrecheck) =>
    set((state) => ({
      qualityData: {
        ...state.qualityData,
        ...qualityData,
      },
    })),
  setHasStarted: (hasStarted: boolean) => set({ hasStarted }),
});
